module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/scroll-dd63b81dea359d0ded63aa5ec915aacf.png";